import AlgorithmDetailPage from '@/modules/quant/algorithms/algorithm-detail-page';
import { requireCapability } from '@/utils/route-guards';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_dashboard/dashboard/quant/algorithms/$algorithmId',
)({
  beforeLoad: () => requireCapability('quantLab'),
  component: RouteComponent,
});

function RouteComponent(): JSX.Element {
  const { algorithmId } = Route.useParams();
  return <AlgorithmDetailPage algorithmId={algorithmId} />;
}
